import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { LayerComponent } from './layer.component'
import { CreateLayerComponent } from './create-layer/create-layer.component'
import { UpdateLayerComponent } from './update-layer/update-layer.component'
import { layerRoutes } from './layer.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '@shared/shared.module'
import { LayerMapModule } from '@components/layer-map/layer-map.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'
import { ContentLoadingModule } from '@components/content-loading/content-loading.module'

@NgModule({
  declarations: [LayerComponent, CreateLayerComponent, UpdateLayerComponent],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(layerRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    LayerMapModule,
    BreadcrumbsModule,
    ContentLoadingModule,
  ],
  exports: [LayerComponent, CreateLayerComponent, UpdateLayerComponent],
})
export class LayerModule {}
